<template>
  <aside>
    <el-menu
      :collapse="isCollapseNavLeft"
      :unique-opened="true"
      :router="true"
      :default-active="$route.path"
    >
      <div
        v-loading="loadingAccount"
        v-loading.fullscreen.lock="loadingFullScreem"
        class="nav-header"
      >
        <el-dropdown trigger="click" @command="handleAccount">
          <span class="el-dropdown-link">
            <Logo />
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="acc in accounts" :key="acc.id" :command="acc.id">
              <div class="clearfix">
                <span style="float: left; margin-right: 15px">{{
                  acc.name.slice(0, 30)
                }}</span>
                <span
                  v-if="acc.id === currentAccount.id"
                  style="float: right; margin-top: 4px"
                >
                  <CheckIcon size="1.2x" class="svg-primary"></CheckIcon>        </span>
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <svg
          @click="changeCollapse"
          class="icon"
          xmlns="http://www.w3.org/2000/svg"
          width="17.467"
          height="14.142"
          viewBox="0 0 17.467 14.142"
        >
          <g
            id="Icon_feather-menu"
            data-name="Icon feather-menu"
            transform="translate(-3.35 -7.85)"
          >
            <path
              id="Caminho_1"
              data-name="Caminho 1"
              d="M4.5,18H17.667"
              transform="translate(0 -4.079)"
              fill="none"
              stroke="#505050"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2.3"
            />
            <path
              id="Caminho_2"
              data-name="Caminho 2"
              d="M4.5,9H17.667"
              fill="none"
              stroke="#505050"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2.3"
            />
            <path
              id="Caminho_3"
              data-name="Caminho 3"
              d="M4.5,27H17.667"
              transform="translate(0 -8.158)"
              fill="none"
              stroke="#505050"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2.3"
            />
          </g>
        </svg>
      </div>
      <div class="scroll">
        <el-menu-item
          v-if="$can('4|5')"
          :index="
            $router.options.routes.find((x) => x.name === 'home').path +
            '/' +
            $router.options.routes.find((x) => x.name === 'home').children[0].path
          "
        >
          <home-icon size="1.1x" class="el-icon-"></home-icon>
          <span slot="title"
            >{{
              $router.options.routes.find((x) => x.name === "home").children[0].meta.title
            }}
          </span>
        </el-menu-item>
        <el-menu-item
            v-if="$can('1|2|6')"
            :index="
            $router.options.routes.find((x) => x.name === 'home').path +
            '/' +
            $router.options.routes.find((x) => x.name === 'home').children[1].path
          "
        >
          <home-icon size="1.1x" class="el-icon-"></home-icon>
          <span slot="title"
          >{{
              $router.options.routes.find((x) => x.name === "home").children[1].meta.title
            }}
          </span>
        </el-menu-item>
        <el-submenu index="management">
          <template slot="title">
            <GlobeIcon size="1.1x" class="el-icon-"></GlobeIcon>
            <span>Gestão do Meu Negocio</span>
          </template>
          <el-menu-item v-if="$can('1|2|4|6')" :index="this.$router.options.routes.find(x => x.name === 'management').path + '/' + $router.options.routes.find(x => x.name === 'management').children.find(y => y.name === 'management.onboarding.index').path">
            {{ $router.options.routes.find(x => x.name === 'management').children.find(y => y.name === 'management.onboarding.index').meta.titleMenu }}
          </el-menu-item>
          <el-menu-item v-if="$can('1|2|4|6')" :index="this.$router.options.routes.find(x => x.name === 'management').path + '/' + $router.options.routes.find(x => x.name === 'management').children.find(y => y.name === 'management.activation.index').path">
            {{ $router.options.routes.find(x => x.name === 'management').children.find(y => y.name === 'management.activation.index').meta.titleMenu }}
          </el-menu-item>
          <!-- <el-menu-item v-if="$can('1')" :index="this.$router.options.routes.find(x => x.name === 'management').path + '/' + $router.options.routes.find(x => x.name === 'management').children.find(y => y.name === 'management.operational.index').path">
            {{ $router.options.routes.find(x => x.name === 'management').children.find(y => y.name === 'management.operational.index').meta.titleMenu }}
          </el-menu-item> -->
        </el-submenu>
        <el-submenu index="reports">
          <template slot="title">
            <FolderIcon size="1.1x" class="el-icon-"></FolderIcon>
            <span>Cadastros</span>
          </template>
          <el-menu-item
            v-if="$can('1|')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'records').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'records')
                .children.find((y) => y.name === 'records.gerentemarketplaces.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "records")
                .children.find((y) => y.name === "records.gerentemarketplaces.index").meta
                .titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            v-if="$can('1|6')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'records').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'records')
                .children.find((y) => y.name === 'records.marketplaces.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "records")
                .children.find((y) => y.name === "records.marketplaces.index").meta
                .titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            v-if="$can('1|2|4|5|6')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'records').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'records')
                .children.find((y) => y.name === 'records.departments.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "records")
                .children.find((y) => y.name === "records.departments.index").meta
                .titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            v-if="$can('1|2|6')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'records').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'records')
                .children.find((y) => y.name === 'records.plan.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "records")
                .children.find((y) => y.name === "records.plan.index").meta.titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            v-if="$can('1|2|4|6')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'records').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'records')
                .children.find((y) => y.name === 'records.terminal.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "records")
                .children.find((y) => y.name === "records.terminal.index").meta.titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            v-if="$can('1')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'records').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'records')
                .children.find((y) => y.name === 'records.modelEquipment.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "records")
                .children.find((y) => y.name === "records.modelEquipment.index").meta
                .titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            v-if="$can('1|2|4|6')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'records').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'records')
                .children.find((y) => y.name === 'records.equipment.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "records")
                .children.find((y) => y.name === "records.equipment.index").meta.titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            v-if="$can('1|2|5|6')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'records').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'records')
                .children.find((y) => y.name === 'records.users.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "records")
                .children.find((y) => y.name === "records.users.index").meta.titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            v-if="$can('1|2|6')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'records').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'records')
                .children.find((y) => y.name === 'records.representante.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "records")
                .children.find((y) => y.name === "records.representante.index").meta
                .titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            v-if="$can('1')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'records').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'records')
                .children.find((y) => y.name === 'records.approveAccount.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "records")
                .children.find((y) => y.name === "records.approveAccount.index").meta
                .titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            v-if="$can('1')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'records').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'records')
                .children.find((y) => y.name === 'records.riskAnalysis.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "records")
                .children.find((y) => y.name === "records.riskAnalysis.index").meta
                .titleMenu
            }}
          </el-menu-item>
        </el-submenu>
        <el-submenu index="financial">
          <template slot="title">
            <PercentIcon size="1.1x" class="el-icon-"></PercentIcon>
            <span>Financeiro</span>
          </template>
          <el-menu-item
            v-if="$can('1|2|6')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'financial').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'financial')
                .children.find((y) => y.name === 'financial.paymentConfigAdjust.index')
                .path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "financial")
                .children.find((y) => y.name === "financial.paymentConfigAdjust.index")
                .meta.titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            v-if="$can('1|2|4|5|6')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'financial').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'financial')
                .children.find((y) => y.name === 'financial.transation.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "financial")
                .children.find((y) => y.name === "financial.transation.index").meta
                .titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            v-if="currentUser.supAdmin == 1 && $can('1')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'financial').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'financial')
                .children.find((y) => y.name === 'financial.transationv3.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "financial")
                .children.find((y) => y.name === "financial.transationv3.index").meta
                .titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            v-if="$can('1')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'financial').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'financial')
                .children.find((y) => y.name === 'financial.transationrisk.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "financial")
                .children.find((y) => y.name === "financial.transationrisk.index").meta
                .titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            v-if="currentUser.supAdmin == 1 && $can('1')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'financial').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'financial')
                .children.find((y) => y.name === 'financial.transationonlinerisk.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "financial")
                .children.find((y) => y.name === "financial.transationonlinerisk.index").meta
                .titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            v-if="currentUser.supAdmin == 1 && $can('1')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'financial').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'financial')
                .children.find((y) => y.name === 'financial.transationriskv3.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "financial")
                .children.find((y) => y.name === "financial.transationriskv3.index").meta
                .titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            v-if="$can('1')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'financial').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'financial')
                .children.find((y) => y.name === 'financial.logTransation.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "financial")
                .children.find((y) => y.name === "financial.logTransation.index").meta
                .titleMenu
            }}
          </el-menu-item>
          <el-menu-item
              v-if="(
                  $can('1') ||
                   ($can('5') && ($can('PAYMENT_LINK_UNIQUE') || $can('PAYMENT_LINK_SUBSCRIPTION'))) ||
                    ($can('2') && currentUser.marketplace.status_digital_ecs) ||
                   ($can('6') && currentUser.marketplace_manager.status_digital_ecs)
              )"
              :index="
              this.$router.options.routes.find((x) => x.name === 'financial').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'financial')
                .children.find((y) => y.name === 'financial.paymentLink.index').path
            "
          >
            {{
              $router.options.routes
                  .find((x) => x.name === "financial")
                  .children.find((y) => y.name === "financial.paymentLink.index").meta
                  .titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            v-if="currentUser.supAdmin == 1 && $can('1')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'financial').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'financial')
                .children.find((y) => y.name === 'financial.depositv3.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "financial")
                .children.find((y) => y.name === "financial.depositv3.index").meta
                .titleMenu
            }}
          </el-menu-item>

          <el-menu-item
            v-if="$can('1|SCHEDULE_ANTICIPATION')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'financial').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'financial')
                .children.find((y) => y.name === 'financial.anticipationSchedules.index')
                .path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "financial")
                .children.find((y) => y.name === "financial.anticipationSchedules.index")
                .meta.titleMenu
            }}
          </el-menu-item>
          <el-menu-item v-if="$can('1')" :index="this.$router.options.routes.find(x => x.name === 'financial').path + '/' + $router.options.routes.find(x => x.name === 'financial').children.find(y => y.name === 'financial.marketplace_receivable.index').path">
            {{ $router.options.routes.find(x => x.name === 'financial').children.find(y => y.name === 'financial.marketplace_receivable.index').meta.titleMenu }}
          </el-menu-item>
          <el-menu-item v-if="currentUser.supAdmin == 1 && $can('1')" :index="this.$router.options.routes.find(x => x.name === 'financial').path + '/' + $router.options.routes.find(x => x.name === 'financial').children.find(y => y.name === 'financial.receivablev3.index').path">
            {{ $router.options.routes.find(x => x.name === 'financial').children.find(y => y.name === 'financial.receivablev3.index').meta.titleMenu }}
          </el-menu-item>
          <el-menu-item
            v-if="$can('1|2|5|6')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'financial').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'financial')
                .children.find((y) => y.name === 'financial.receivable.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "financial")
                .children.find((y) => y.name === "financial.receivable.index").meta
                .titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            v-if="currentUser.supAdmin == 1 && $can('1')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'financial').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'financial')
                .children.find((y) => y.name === 'financial.receivablev3.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "financial")
                .children.find((y) => y.name === "financial.receivablev3.index").meta
                .titleMenu
            }}
          </el-menu-item>
          <el-menu-item
              v-if="$can('1')"
              :index="
              this.$router.options.routes.find((x) => x.name === 'financial').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'financial')
                .children.find((y) => y.name === 'financial.payment_ec_split.index').path
            "
          >
            {{
              $router.options.routes
                  .find((x) => x.name === "financial")
                  .children.find((y) => y.name === "financial.payment_ec_split.index").meta.titleMenu
            }}
          </el-menu-item>
          <el-menu-item
              v-if="$can('1')"
              :index="
              this.$router.options.routes.find((x) => x.name === 'financial').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'financial')
                .children.find((y) => y.name === 'financial.payment_marketplace_split.index').path
            "
          >
            {{
              $router.options.routes
                  .find((x) => x.name === "financial")
                  .children.find((y) => y.name === "financial.payment_marketplace_split.index").meta.titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            v-if="$can('1')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'financial').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'financial')
                .children.find((y) => y.name === 'financial.paymentExport.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "financial")
                .children.find((y) => y.name === "financial.paymentExport.index").meta
                .titleMenu
            }}
          </el-menu-item>
          <el-menu-item
              v-if="$can('1')"
              :index="
              this.$router.options.routes.find((x) => x.name === 'financial').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'financial')
                .children.find((y) => y.name === 'financial.payment_bank_slip_batche.index').path
            "
          >
            {{
              $router.options.routes
                  .find((x) => x.name === "financial")
                  .children.find((y) => y.name === "financial.payment_bank_slip_batche.index").meta.titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            v-if="$can('1')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'financial').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'financial')
                .children.find((y) => y.name === 'financial.pagamentoMaketplace.index')
                .path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "financial")
                .children.find((y) => y.name === "financial.pagamentoMaketplace.index")
                .meta.titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            v-if="$can('1')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'financial').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'financial')
                .children.find((y) => y.name === 'financial.markupRepresentante.index')
                .path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "financial")
                .children.find((y) => y.name === "financial.markupRepresentante.index")
                .meta.titleMenu
            }}
          </el-menu-item>
        </el-submenu>
        <el-submenu index="report">
          <template slot="title">
            <PrinterIcon size="1.1x" class="el-icon-"></PrinterIcon>
            <span>Relatórios</span>
          </template>
          <el-menu-item
            v-if="$can('1|2|6')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'report').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'report')
                .children.find((y) => y.name === 'report.ajustFinanceiro.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "report")
                .children.find((y) => y.name === "report.ajustFinanceiro.index").meta
                .titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            v-if="$can('1|2|4|6')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'report').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'report')
                .children.find((y) => y.name === 'report.equipment.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "report")
                .children.find((y) => y.name === "report.equipment.index").meta.titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            :index="
              this.$router.options.routes.find((x) => x.name === 'report').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'report')
                .children.find((y) => y.name === 'report.terminal.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "report")
                .children.find((y) => y.name === "report.terminal.index").meta.titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            v-if="$can('1|2|4|6')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'report').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'report')
                .children.find((y) => y.name === 'report.ec.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "report")
                .children.find((y) => y.name === "report.ec.index").meta.titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            v-if="$can('1|2|6')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'report').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'report')
                .children.find((y) => y.name === 'report.integrationMerchant.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "report")
                .children.find((y) => y.name === "report.integrationMerchant.index").meta
                .titleMenu
            }}
          </el-menu-item>
          <el-menu-item v-if="$can('1')" :index="this.$router.options.routes.find(x => x.name === 'report').path + '/' + $router.options.routes.find(x => x.name === 'report').children.find(y => y.name === 'report.marketplace_receivables.index').path">
            {{ $router.options.routes.find(x => x.name === 'report').children.find(y => y.name === 'report.marketplace_receivables.index').meta.titleMenu }}
          </el-menu-item>
          <el-menu-item
            v-if="$can('1|6')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'report').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'report')
                .children.find((y) => y.name === 'report.integrationReseller.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "report")
                .children.find((y) => y.name === "report.integrationReseller.index").meta
                .titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            v-if="$can('1|2|4|5|6')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'report').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'report')
                .children.find((y) => y.name === 'report.receivables.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "report")
                .children.find((y) => y.name === "report.receivables.index").meta
                .titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            v-if="currentUser.supAdmin == 1 && $can('1')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'report').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'report')
                .children.find((y) => y.name === 'report.receivablesv3.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "report")
                .children.find((y) => y.name === "report.receivablesv3.index").meta
                .titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            v-if="$can('1')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'report').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'report')
                .children.find((y) => y.name === 'report.conciliationStone.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "report")
                .children.find((y) => y.name === "report.conciliationStone.index").meta
                .titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            v-if="currentUser.supAdmin == 1 && $can('1')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'report').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'report')
                .children.find((y) => y.name === 'report.conciliationStonev3.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "report")
                .children.find((y) => y.name === "report.conciliationStonev3.index").meta
                .titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            v-if="$can('1|2|4|5|6')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'report').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'report')
                .children.find((y) => y.name === 'report.transaction.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "report")
                .children.find((y) => y.name === "report.transaction.index").meta
                .titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            v-if="currentUser.supAdmin == 1 && $can('1')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'report').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'report')
                .children.find((y) => y.name === 'report.transactionv3.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "report")
                .children.find((y) => y.name === "report.transactionv3.index").meta
                .titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            v-if="$can('1|2|4|6')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'report').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'report')
                .children.find((y) => y.name === 'report.customer.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "report")
                .children.find((y) => y.name === "report.customer.index").meta.titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            v-if="$can('1|2')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'report').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'report')
                .children.find((y) => y.name === 'report.riskAnalysis.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "report")
                .children.find((y) => y.name === "report.riskAnalysis.index").meta
                .titleMenu
            }}
          </el-menu-item>
        </el-submenu>
        <el-submenu index="integration" v-if="$can('1|2|6')">
          <template slot="title">
            <SettingsIcon size="1.1x" class="el-icon-"></SettingsIcon>
            <span>API de Integração</span>
          </template>
          <el-menu-item
              :index="
              this.$router.options.routes.find((x) => x.name === 'config').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'config')
                .children.find((y) => y.name === 'integration.apiclient.view').path
            "
          >
            {{
              $router.options.routes
                  .find((x) => x.name === "config")
                  .children.find((y) => y.name === "integration.apiclient.view").meta
                  .titleMenu
            }}
          </el-menu-item>
          <el-menu-item
              :index="'integration.apiclient.documentation'"
              @click="handleOpenDocs"
              style="display: flex; align-items: center;"
          >
            Documentação
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width: 1rem; margin-left: .2rem;">
              <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
            </svg>
          </el-menu-item>
        </el-submenu>
        <el-submenu index="config" v-if="$can('1|PROFILE_MANAGER')">
          <template slot="title">
            <SettingsIcon size="1.1x" class="el-icon-"></SettingsIcon>
            <span>Configurações</span>
          </template>
          <el-menu-item
            :index="
              this.$router.options.routes.find((x) => x.name === 'config').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'config')
                .children.find((y) => y.name === 'config.payment-adjust-type.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "config")
                .children.find((y) => y.name === "config.payment-adjust-type.index").meta.titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            :index="
              this.$router.options.routes.find((x) => x.name === 'config').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'config')
                .children.find((y) => y.name === 'config.product.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "config")
                .children.find((y) => y.name === "config.product.index").meta.titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            v-if="$can('PROFILE_MANAGER')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'config').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'config')
                .children.find((y) => y.name === 'config.auth_profile.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "config")
                .children.find((y) => y.name === "config.auth_profile.index").meta.titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            :index="
              this.$router.options.routes.find((x) => x.name === 'config').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'config')
                .children.find((y) => y.name === 'config.apiclient.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "config")
                .children.find((y) => y.name === "config.apiclient.index").meta.titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            :index="
              this.$router.options.routes.find((x) => x.name === 'config').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'config')
                .children.find((y) => y.name === 'config.custooperacionais.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "config")
                .children.find((y) => y.name === "config.custooperacionais.index").meta
                .titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            :index="
              this.$router.options.routes.find((x) => x.name === 'config').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'config')
                .children.find((y) => y.name === 'config.lojista.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "config")
                .children.find((y) => y.name === "config.lojista.index").meta.titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            :index="
              this.$router.options.routes.find((x) => x.name === 'config').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'config')
                .children.find((y) => y.name === 'config.mcc.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "config")
                .children.find((y) => y.name === "config.mcc.index").meta.titleMenu
            }}
          </el-menu-item>

          <el-menu-item
            :index="
              this.$router.options.routes.find((x) => x.name === 'config').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'config')
                .children.find((y) => y.name === 'config.bank.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "config")
                .children.find((y) => y.name === "config.bank.index").meta.titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            :index="
              this.$router.options.routes.find((x) => x.name === 'config').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'config')
                .children.find((y) => y.name === 'config.phoneOperator.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "config")
                .children.find((y) => y.name === "config.phoneOperator.index").meta
                .titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            :index="
              this.$router.options.routes.find((x) => x.name === 'config').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'config')
                .children.find((y) => y.name === 'config.holiday.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "config")
                .children.find((y) => y.name === "config.holiday.index").meta.titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            :index="
              this.$router.options.routes.find((x) => x.name === 'config').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'config')
                .children.find((y) => y.name === 'config.cardbrand.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "config")
                .children.find((y) => y.name === "config.cardbrand.index").meta.titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            :index="
              this.$router.options.routes.find((x) => x.name === 'config').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'config')
                .children.find((y) => y.name === 'config.ListMigracoes.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "config")
                .children.find((y) => y.name === "config.ListMigracoes.index").meta
                .titleMenu
            }}
          </el-menu-item>
        </el-submenu>
        <el-submenu index="financial_management" v-if="$can('1|2|4|5|6')">
          <template slot="title">
            <DollarSignIcon size="1.1x" class="el-icon-"></DollarSignIcon>
            <span>Gestão Financeira</span>
          </template>
          <el-menu-item
              :index="
              this.$router.options.routes.find((x) => x.name === 'financial_management').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'financial_management')
                .children.find((y) => y.name === 'financial_management.deposit.index').path
            "
          >
            {{
              $router.options.routes
                  .find((x) => x.name === "financial_management")
                  .children.find((y) => y.name === "financial_management.deposit.index").meta.titleMenu
            }}
          </el-menu-item>
          <el-menu-item
              :index="
              this.$router.options.routes.find((x) => x.name === 'financial_management').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'financial_management')
                .children.find((y) => y.name === 'financial_management.paymentAdjust.index').path
            "
          >
            {{
              $router.options.routes
                  .find((x) => x.name === "financial_management")
                  .children.find((y) => y.name === "financial_management.paymentAdjust.index").meta
                  .titleMenu
            }}
          </el-menu-item>
          <el-menu-item
              v-if="$can('1|2|5|6')"
              :index="
              this.$router.options.routes.find((x) => x.name === 'financial_management').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'financial_management')
                .children.find((y) => y.name === 'financial_management.extract.index').path
            "
          >
            {{
              $router.options.routes
                  .find((x) => x.name === "financial_management")
                  .children.find((y) => y.name === "financial_management.extract.index").meta
                  .titleMenu
            }}
          </el-menu-item>
          <el-menu-item
            v-if="$can('1|2|5|6')"
            :index="
              this.$router.options.routes.find((x) => x.name === 'financial_management').path +
              '/' +
              $router.options.routes
                .find((x) => x.name === 'financial_management')
                .children.find((y) => y.name === 'financial_management.payment.index').path
            "
          >
            {{
              $router.options.routes
                .find((x) => x.name === "financial_management")
                .children.find((y) => y.name === "financial_management.payment.index").meta.titleMenu
            }}
          </el-menu-item>
        </el-submenu>
      </div>
    </el-menu>
  </aside>
</template>

<script>
import { mapGetters } from "vuex";
import {
  HomeIcon,
  SettingsIcon,
  FolderIcon,
  PercentIcon,
  PrinterIcon,
  GlobeIcon,
  DollarSignIcon
} from "vue-feather-icons";
import { switchAccount } from "../../services";
import { loadUserData } from "../../../Auth/services";
import Logo from "./Logo";

export default {
  name: "NavLeft",
  props: ["isCollapseNavLeft"],
  data() {
    return {
      loadingFullScreem: false,
      loadingAccount: false,
      accounts: [],
    };
  },
  components: {
    HomeIcon,
    SettingsIcon,
    FolderIcon,
    PercentIcon,
    Logo,
    PrinterIcon,
    GlobeIcon,
    DollarSignIcon,
  },
  computed: {
    ...mapGetters("Auth", ["currentAccount", "currentUser"]),
  },
  methods: {
    async handleAccount(accid) {
      this.loadingFullScreem = true;
      try {
        await switchAccount(accid);
        await this.loadUSER();
      } catch (e) {
        this.$message({
          showClose: true,
          message: e.body.error.message,
          type: "error",
        });
      }
    },
    async loadUSER() {
      try {
        let response = await loadUserData();
        this.$store.commit("Auth/SET_USER", response);
      } catch (e) {
        this.$message({
          showClose: true,
          message: e.body.error.message,
          type: "error",
        });
      } finally {
        this.loadingFullScreem = false;
      }
    },
    changeCollapse() {
      this.$emit("setCollapse", !this.isCollapseNavLeft);
    },
    handleOpenDocs() {
      window.open('https://integration.cappta.com.br/', '_blank');
    }
  },
  mounted() {
    // this.loadAccounts()
  },
};
</script>
